import { fromJS } from 'immutable';
import * as actions from './actionTypes';
import { getErrorCode, getErrorMessage } from '../../containers/Error';

export const stateKey = 'ServicesStore';

const initialState = fromJS({
  uber: {
    createVoucher:
    {
      loading: false,
      resolved: false,
      error: { error: false, code: null, message: null, type: null, state: 'services' },
    },
  },
  enterprise: {
    searchLocations:
    {
      loading: false,
      data: null,
      error: { error: false, code: null, message: null, type: null, state: 'services' },
    },
    createRental:
    {
      loading: false,
      resolved: false,
      error: { error: false, code: null, message: null, type: null, state: 'services' },
    },
  },
  audatarget: {
    searchVendor:
    {
      loading: false,
      data: null,
      error: { error: false, code: null, message: null, type: null, state: 'services' },
    },
    availability:
    {
      loading: false,
      data: null,
      error: { error: false, code: null, message: null, type: null, state: 'services' },
    },
    bookAppointment:
    {
      loading: false,
      resolved: false,
      error: { error: false, code: null, message: null, type: null, state: 'services' },
    },
  },
});

const servicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.CREATE_UBER_VOUCHER:
      return state
        .setIn(['uber', 'createVoucher', 'loading'], true);

    case actions.CREATE_UBER_VOUCHER_SUCCESS:
      return state
        .setIn(['uber', 'createVoucher', 'resolved'], true)
        .setIn(['uber', 'createVoucher', 'loading'], false);

    case actions.CREATE_UBER_VOUCHER_FAILED:
      return state
        .setIn(['uber', 'createVoucher', 'resolved'], false)
        .setIn(['uber', 'createVoucher', 'loading'], false)
        .setIn(['uber', 'createVoucher', 'error', 'error'], true)
        .setIn(['uber', 'createVoucher', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['uber', 'createVoucher', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['uber', 'createVoucher', 'error', 'type'], action.type);

    case actions.CREATE_RENTAL:
      return state
        .setIn(['enterprise', 'createRental', 'loading'], true);

    case actions.CREATE_RENTAL_SUCCESS:
      return state
        .setIn(['enterprise', 'createRental', 'resolved'], true)
        .setIn(['enterprise', 'createRental', 'loading'], false);

    case actions.CREATE_RENTAL_FAILED:
      return state
        .setIn(['enterprise', 'createRental', 'resolved'], false)
        .setIn(['enterprise', 'createRental', 'loading'], false)
        .setIn(['enterprise', 'createRental', 'error', 'error'], true)
        .setIn(['enterprise', 'createRental', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['enterprise', 'createRental', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['enterprise', 'createRental', 'error', 'type'], action.type);

    case actions.ENTERPRISE_SEARCH_LOCATIONS:
      return state
        .setIn(['enterprise', 'searchLocations', 'loading'], true);

    case actions.ENTERPRISE_SEARCH_LOCATIONS_SUCCESS:
      return state
        .setIn(['enterprise', 'searchLocations', 'data'], action.payload.data)
        .setIn(['enterprise', 'searchLocations', 'loading'], false);

    case actions.ENTERPRISE_SEARCH_LOCATIONS_FAILED:
      return state
        .setIn(['enterprise', 'searchLocations', 'loading'], false)
        .setIn(['enterprise', 'searchLocations', 'error', 'error'], true)
        .setIn(['enterprise', 'searchLocations', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['enterprise', 'searchLocations', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['enterprise', 'searchLocations', 'error', 'type'], action.type);

    case actions.AUDATARGET_SEARCH_VENDOR:
      return state
        .setIn(['audatarget', 'searchVendor', 'loading'], true);

    case actions.AUDATARGET_SEARCH_VENDOR_SUCCESS:
      return state
        .setIn(['audatarget', 'searchVendor', 'loading'], false)
        .setIn(['audatarget', 'searchVendor', 'data'], action.payload.data);

    case actions.AUDATARGET_SEARCH_VENDOR_FAILED:
      return state
        .setIn(['audatarget', 'searchVendor', 'loading'], false)
        .setIn(['audatarget', 'searchVendor', 'error', 'error'], true)
        .setIn(['audatarget', 'searchVendor', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['audatarget', 'searchVendor', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['audatarget', 'searchVendor', 'error', 'type'], action.type);

    case actions.AUDATARGET_GET_AVAILABILITY:
      return state
        .setIn(['audatarget', 'availability', 'loading'], true);

    case actions.AUDATARGET_GET_AVAILABILITY_SUCCESS:
      return state
        .setIn(['audatarget', 'availability', 'loading'], false)
        .setIn(['audatarget', 'availability', 'data'], action.payload.data);

    case actions.AUDATARGET_GET_AVAILABILITY_FAILED:
      return state
        .setIn(['audatarget', 'availability', 'loading'], false)
        .setIn(['audatarget', 'availability', 'error', 'error'], true)
        .setIn(['audatarget', 'availability', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['audatarget', 'availability', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['audatarget', 'availability', 'error', 'type'], action.type);

    case actions.AUDATARGET_BOOK_APPOINTMENT:
      return state
        .setIn(['audatarget', 'bookAppointment', 'loading'], true);

    case actions.AUDATARGET_BOOK_APPOINTMENT_SUCCESS:
      return state
        .setIn(['audatarget', 'bookAppointment', 'loading'], false)
        .setIn(['audatarget', 'bookAppointment', 'resolved'], true);

    case actions.AUDATARGET_BOOK_APPOINTMENT_FAILED:
      return state
        .setIn(['audatarget', 'bookAppointment', 'loading'], false)
        .setIn(['enterprise', 'bookAppointment', 'resolved'], false)
        .setIn(['audatarget', 'bookAppointment', 'error', 'error'], true)
        .setIn(['audatarget', 'bookAppointment', 'error', 'code'], getErrorCode(action.payload.error))
        .setIn(['audatarget', 'bookAppointment', 'error', 'message'], getErrorMessage(action.payload.error))
        .setIn(['audatarget', 'bookAppointment', 'error', 'type'], action.type);

    case actions.CLEAR_ERRORS:
      return state
        .setIn(['uber', 'createVoucher', 'error', 'error'], false)
        .setIn(['enterprise', 'createRental', 'error', 'error'], false)
        .setIn(['enterprise', 'searchLocations', 'error', 'error'], false)
        .setIn(['audatarget', 'searchVendor', 'error', 'error'], false)
        .setIn(['audatarget', 'availability', 'error', 'error'], false)
        .setIn(['audatarget', 'bookAppointment', 'error', 'error'], false);

    case actions.CLEAR_STATE:
      return initialState;

    default:
      return state;
  }
};

export default servicesReducer;
